// @flow

import * as React from 'react';

import { emitter } from '../utils';

type RefetchControllerProps = {
  condition: boolean | Array<boolean | string | number>,
  refetch: any,
  listenForRefetchEvent?: boolean,
  checkForFefetch?: () => void,
  level: string,
};

const evalCondition = ({ condition, prevCondition, props, prevProps }) => {
  if (typeof condition === 'function') {
    return condition(props, prevProps);
  }

  return condition && condition !== prevCondition;
};

export default class RefetchController extends React.Component<RefetchControllerProps> {
  componentDidMount() {
    if (this.props.listenForRefetchEvent) {
      emitter.on('pst-refetch', this.props.refetch);
    }

    if (typeof this.props.checkForFefetch === 'function') {
      emitter.on('pst-check-refetch', this.props.checkForFefetch);
    }
  }

  componentDidUpdate(prevProps: RefetchControllerProps) {
    const cond = Array.isArray(this.props.condition)
      ? this.props.condition.some(
          // $FlowFixMe
          (condition, i) =>
            evalCondition({
              condition,
              prevCondition: prevProps.condition[i],
              props: this.props,
              prevProps: prevProps,
            }),
        )
      : evalCondition({
          condition: this.props.condition,
          prevCondition: prevProps.condition,
          props: this.props,
          prevProps: prevProps,
        });

    if (cond || (this.props.level && this.props.level !== prevProps.level)) {
      this.props.refetch();
    }
  }

  render() {
    return null;
  }
}
